import React from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <a href="https://wa.link/ut4sjx" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-teal-600 text-white px-4 py-3 rounded-full shadow-2xl hover:shadow-3xl hover:scale-105 hover:bg-teal-700 transition-all duration-300 flex items-center gap-2 font-medium text-sm md:text-base group" data-id="element-243">
      <MessageCircle className="w-5 h-5 md:w-6 md:h-6" data-id="element-244" />
      <span className="hidden sm:inline" data-id="element-245">Soporte WhatsApp</span>
    </a>;
}